import {
  req
} from '@/utils/http'

// Login api
const login = (username, password) => {
  return req.post('/p/v1/login', {
    username,
    password
  })
}

export default {
  login
}



// WEBPACK FOOTER //
// ./src/api/loginApi.js